module.exports = __webpack_public_path__ + "img/findmajor.76b3201a.png";